function tabs() {
  const allPostTab = document.getElementById('tab-all-post');
  const otherTabs = document.querySelectorAll('#tabs .tab:not(#tab-all-post)');

  const featuredContents = document.querySelectorAll('.featured-content');
  const dynamicContents = document.querySelectorAll('.dynamic-content');

  allPostTab.addEventListener('click', () => {
    allPostTab.classList.add('active');
    otherTabs.forEach(tab => {
      tab.classList.remove('active');
    })

    featuredContents.forEach(content => {
      content.classList.remove('hidden');
    })

    dynamicContents.forEach(content => {
      content.classList.add('hidden');
    })
  })
  
  otherTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      allPostTab.classList.remove('active');
      otherTabs.forEach(tab => {
        tab.classList.remove('active');
      })
      tab.classList.add('active');

      featuredContents.forEach(content => {
        content.classList.add('hidden');
      })

      const tabSlug = tab.dataset.tagSlug;
      dynamicContents.forEach(content => {
        const contentSlug = content.dataset.tagSlug;

        if (contentSlug === tabSlug) { 
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      })
    });
  });
}
